import React from "react";
import FormBuilder from "./FormBuilder";

const FormTemplateBuilder: React.FC = () => {
    return (
        <FormBuilder template={true} />
    );
};

export default FormTemplateBuilder;